import { render, staticRenderFns } from "./PremiumFunding.vue?vue&type=template&id=0517fbb0&scoped=true&"
import script from "./PremiumFunding.vue?vue&type=script&lang=ts&"
export * from "./PremiumFunding.vue?vue&type=script&lang=ts&"
import style0 from "./PremiumFunding.vue?vue&type=style&index=0&id=0517fbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0517fbb0",
  null
  
)

export default component.exports